export default __webpack_public_path__ + "ui/assets/img/arrow-right-info_small.svg";